import { useState } from 'react';
import { t } from '../i18n/i18n';
import { store, useApp } from '../state/store';
import { newProject, saveCurrentProject } from './actions';
import { IconClose, IconSave } from './icons';

/** Asked before a new project replaces one with unsaved changes. */
export function NewProjectDialog() {
  const name = useApp((s) => s.project.name.trim() || t('Untitled'));
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const close = () => store.set({ panel: null });

  const saveAndNew = async () => {
    setBusy(true);
    setError(null);
    try {
      await saveCurrentProject();
      newProject();
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
      setBusy(false);
    }
  };

  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="new-title" onKeyDown={(e) => e.key === 'Escape' && close()}>
      <div className="modal" style={{ width: 'min(460px, 100%)' }}>
        <div className="modal-head">
          <h2 id="new-title">{t('Start a new project?')}</h2>
          <button className="btn icon ghost" aria-label={t('Close dialog')} onClick={close}>
            <IconClose />
          </button>
        </div>
        <div className="modal-body">
          <p style={{ margin: 0 }}>{t('“{name}” has unsaved changes. Do you want to save them before you start a new project?', { name })}</p>
          {error && (
            <p className="issue error" role="alert" style={{ marginTop: 12 }}>
              {error}
            </p>
          )}
        </div>
        <div className="modal-foot">
          <button className="btn" onClick={close} disabled={busy}>
            {t('Cancel')}
          </button>
          <button className="btn" onClick={() => newProject()} disabled={busy}>
            {t('Discard changes')}
          </button>
          <button className="btn primary" onClick={() => void saveAndNew()} disabled={busy} autoFocus>
            <IconSave size={14} /> {t('Save and start new')}
          </button>
        </div>
      </div>
    </div>
  );
}
